"use client";

import { createContext, useContext } from "react";

import { CarePlanContextType } from "./types";

export const CarePlanContext = createContext<CarePlanContextType | null>(null);

export function useCarePlanContext(): CarePlanContextType {
  const ctx = useContext(CarePlanContext);
  if (!ctx) {
    throw new Error("useCarePlanContext must be used within a CarePlan");
  }
  return ctx;
}
